import EditAvatar from '@/components/EditAvatar'
import { IconFont } from '@/components/IconFont'
import { ID } from '@/services/common.model'
import { createOrganizationProject, updateOrganizationProject } from '@/services/project/project'
import { Project } from '@/services/project/project.model'
import { useRequest } from 'ahooks'
import { Form, Input, Modal, ModalProps, Radio, Select, Space, Typography } from 'antd'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
const { Text } = Typography

interface AddEditProjectModalProps extends ModalProps {
  onSuccess: () => void
  project?: Project.Info
  orgId: ID
}

function AddEditProjectModal(props: AddEditProjectModalProps) {
  const [visible, setVisible] = useState(true)
  const [form] = Form.useForm()
  const name = Form.useWatch('name', form)
  const { project, orgId, onSuccess, onCancel } = props
  const { loading, run } = useRequest(
    (values) => {
      if (project) {
        return updateOrganizationProject({ orgId, id: project.id }, values)
      } else {
        const { rId, ...body } = values
        return createOrganizationProject(orgId, rId, body)
      }
    },
    {
      manual: true,
      onSuccess: () => {
        handleCancel()
        onSuccess()
      }
    }
  )

  const handleCancel = (e?) => {
    setVisible(false)
    onCancel?.(e)
  }

  return (
    (<Modal
      {...props}
      width={660}
      open={visible}
      onCancel={handleCancel}
      confirmLoading={loading}
      title={project ? 'Edit Project' : 'New Project'}
      maskClosable={false}
      onOk={() => form.submit()}
    >
      <Form
        layout='vertical'
        form={form}
        initialValues={project || {}}
        onFinish={async (values) => {
          run(values)
        }}
      >
        <Form.Item label='Project Name' name='name' rules={[{ required: true, message: 'Please enter project name' }]}>
          <Input type='text' placeholder='Project Name' />
        </Form.Item>

        <Form.Item
          label='Project No'
          name='no'
          rules={[
            { required: true, message: 'Please enter project no' },
            { min: 8, message: 'It is typically a string of 8-12 characters' },
            { max: 12, message: 'It is typically a string of 8-12 characters' }
          ]}
        >
          <Input type='text' placeholder='It is typically a string of 8-12 characters' />
        </Form.Item>

        <Form.Item label='Code' name='code' rules={[{ required: true, message: 'Please enter project code' }]}>
          <Input type='text' placeholder='' />
        </Form.Item>

        <Form.Item label='Description' name='description' rules={[]}>
          <Input.TextArea rows={3} placeholder='Add some description of the project' />
        </Form.Item>

        <Form.Item label='Avatar' name='avatar' rules={[]}>
          <EditAvatar colorPlacement={'right'} name={name} metaData={{}} />
        </Form.Item>

        <Form.Item name='personal' rules={[{ required: true, message: 'Required' }]}>
          <Radio.Group className={'bg-container'}>
            <Space direction='vertical'>
              <Radio value={true}>
                <Space align={'start'}>
                  <IconFont type={'icon-company'} />
                  <Space direction='vertical'>
                    <Text>Public</Text>
                    <Text type='secondary'>
                      Anyone on the internet can see this project. You choose who can contribute. Anyone who accesses
                      the project has to accept the terms vou specified.
                    </Text>
                  </Space>
                </Space>
              </Radio>
              <Radio value={false}>
                <Space align={'start'}>
                  <IconFont type={'icon-lock1'} />
                  <Space direction='vertical'>
                    <Text>Private</Text>
                    <Text type='secondary'>
                      You choose who can see and contribute to this project. Anyone who accesses the project has to
                      accept the terms you specified.
                    </Text>
                  </Space>
                </Space>
              </Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>)
  );
}

AddEditProjectModal.show = (props: AddEditProjectModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const clean = () => {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }

  ReactDOM.render(
    <AddEditProjectModal
      {...props}
      onCancel={(e) => {
        props.onCancel?.(e)
        clean()
      }}
    />,
    div
  )
}

export default AddEditProjectModal
